import styled from "styled-components";

const ProjectCard = styled.a`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-decoration: none;
  cursor: pointer;
  group;

  &:hover {
    .image-wrapper {
      transform: translateY(-2px);
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
    }
    img {
      transform: scale(1.02);
    }
  }

  .image-wrapper {
    width: 100%;
    aspect-ratio: 16/9;
    overflow: hidden;
    margin-bottom: 20px;
    border-radius: 4px;
    background: var(--panel-bg);
    border: 1px solid rgba(150, 150, 150, 0.1);
    transition: all 0.3s ease;
    
    @media (min-width: 1024px) {
      /* Removed height override to respect aspect-ratio */
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transform: translateZ(0); /* Force GPU high-res rendering */
    transition: all 0.4s ease;
  }

  div {
    display: flex;
    flex-direction: column;

    .project-header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: 8px;
    }

    .project-title {
      margin: 0;
      font-size: 1.25rem;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0px;
      color: var(--text-color);
    }

    h4 {
      margin: 0;
      font-size: 0.75rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: var(--accent);
    }

    p {
      margin: 0;
      font-size: 0.95rem;
      color: var(--text-color);
      opacity: 0.7;
      margin-top: 8px;
      line-height: 1.4;
    }
  }
`;

export default ProjectCard;